import * as yup from 'yup';
import { buildRequiredEmailLikeSchema } from 'pages/Auth/utils';
import {
  RESEND_ACTIVATION_EMAIL_FORMAT_ERROR,
  RESEND_ACTIVATION_EMAIL_REQUIRED_ERROR,
} from './ResendActivation.constants';

export const RESEND_ACTIVATION_SCHEMA = yup.object({
  identifier: buildRequiredEmailLikeSchema(
    RESEND_ACTIVATION_EMAIL_REQUIRED_ERROR,
    RESEND_ACTIVATION_EMAIL_FORMAT_ERROR,
  ),
});
